
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!./../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-de9170be&scoped=true!stylus-loader!./../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Org.vue")

var Component = require("!./../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Org.vue"),
  /* template */
  require("!!./../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-de9170be!./../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Org.vue"),
  /* scopeId */
  "data-v-de9170be",
  /* cssModules */
  null
)
Component.options.__file = "/app/src/components/Main/Contact/Org.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Org.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-de9170be", Component.options)
  } else {
    hotAPI.reload("data-v-de9170be", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Contact/Org.vue
// module id = 793
// module chunks = 0